import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { errorMessage } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { hasPermission } from "../../lib/permissions";
import { Button } from "../ui/button";
import DeleteWithReasonDialog from "../DeleteWithReasonDialog";

// « Supprimer le compte rendu » (Ordre 28-5) : à la corbeille avec un motif, 30 jours pour le restaurer. Seulement pour qui a le droit
// et a participé à l'assistance (ou voit toutes les assistances) : le serveur répond 404 aux autres.
export default function DeleteAssistNote({ requestId, onDeleted }) {
  const { user } = useAuth();
  const [target, setTarget] = useState(null);
  if (!hasPermission(user, "support:delete_note")) return null;
  return (
    <>
      <Button variant="outline" size="sm" className="text-red-700" onClick={() => setTarget({ id: requestId })} data-testid="assist-note-delete">
        <Trash2 size={14} className="mr-1.5" />Supprimer le compte rendu…
      </Button>
      <DeleteWithReasonDialog
        target={target} testId="delete-assist-note" onClose={() => setTarget(null)}
        title="Supprimer ce compte rendu ?"
        description="Il va dans la corbeille et se restaure pendant 30 jours. L'assistance elle-même n'est pas touchée."
        onConfirm={async (reason) => {
          setTarget(null);
          try {
            await api.delete(`/assist/requests/${requestId}/notes`, { data: { reason } });
            toast.success("Compte rendu mis à la corbeille");
            onDeleted();
          } catch (e) {
            toast.error(errorMessage(e, "Impossible de supprimer ce compte rendu"));
          }
        }}
      />
    </>
  );
}
